/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Room_Temperatures_Building_HelpInputs */



/**
* | output |
* | --- |
* | "Pre-comfort, absence and frost-free temperatures are defined in the building settings" |
*
* @param {Room_Temperatures_Building_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_temperatures_building_help = /** @type {((inputs?: Room_Temperatures_Building_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Temperatures_Building_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-comfort, absence and frost-free temperatures are defined in the building settings")
	return /** @type {LocalizedString} */ ("Les températures de pré-confort, d'absence et d'hors gel sont définies dans les paramètres du bâtiment")
});